<div style="margin-left: 15px;" class="div-27">{{paymentPlaceHolder['LBL_Payment_History']}}</div>
<p style="margin-left: 15px;" class="pt-2">({{paymentPlaceHolder['LBL_PAYUSER_CUSTOM_9']}})
</p>

<!-- <div class="filter-container col-3">
  <label style="width: 75%; " for="marketPlaceFilter">{{placeHolders['LBL_FILTER_BY_STATUS']}}:</label>
  <select id="marketPlaceFilter" class="custom-select" (change)="applyFilter($event)">
      <option value="A">{{placeHolders['LBL_ACTIVE']}}</option>
      <option value="E">{{placeHolders['LBL_EXPIRED']}}</option>
      <option value="">{{placeHolders['LBL_ALL']}}</option>
  </select>
</div> -->

<form class="date-form mb-2">
  <div class="form-group">
    <label for="fromDate">{{paymentPlaceHolder['LBL_FROM']}}:</label>
    <input id="fromDate" [max]="today" type="date" [(ngModel)]="fromDate" name="fromDate" class="date-input" />
  </div>

  <div class="form-group">
    <label for="toDate">{{paymentPlaceHolder['LBL_TODATE']}}:</label>
    <input id="toDate" [max]="today" type="date" [(ngModel)]="toDate" name="toDate" class="date-input" />
  </div>

  <!-- <div class="form-group">
    <label for="selectedDate">Selected Date:</label>
    <input id="selectedDate" type="date" [(ngModel)]="selectedDate" name="selectedDate" class="date-input" />
  </div> -->

  <button type="button" (click)="getWalletData()" class="submit-btn">{{paymentPlaceHolder['LBL_GET_RECORDS']}}</button>
  <button type="button" style="margin-left: 8px;" (click)="generatepaymentPDF()"
    class="submit-btn">{{dashboardPlaceHolder['LBL_BTN_GENERATE_PDF']}}</button>
</form>



<div *ngIf="userData.paymentMode!=='WALLET'" class="table-container table-responsive mat-elevation-z8">
  <table mat-table [dataSource]="dataSource" matSort>

    <!-- Current High Prospects Column -->
    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef>{{paymentPlaceHolder['TBL_TRANSACTION_DATE']}}</th>
      <td mat-cell *matCellDef="let element"> {{element.date | date: 'dd-MM-yyyy'}} </td>
    </ng-container>

    <!-- Deal Title Column -->
    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef> Deal UUID</th>
      <td mat-cell *matCellDef="let element"> {{element.email ? element.email:'NA'}} </td>
    </ng-container>

    <!-- Deal Id Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>{{paymentPlaceHolder['TBL_DEAL_NAME']}}</th>
      <td mat-cell *matCellDef="let element"> {{element.name ? element.name : 'NA'}} </td>
    </ng-container>



    <!-- Valid To Column -->
    <ng-container matColumnDef="amount">
      <th mat-header-cell *matHeaderCellDef style="width: 12%;">{{paymentPlaceHolder['TBL_AMOUNT']}} </th>
      <td mat-cell *matCellDef="let element"> {{element.amount}} </td>
    </ng-container>

    <!-- Status Column -->
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> {{placeHolders['LBL_TBL_STATUS']}} </th>
      <td mat-cell *matCellDef="let element">
        <mat-chip [ngClass]="getStatusClass(element.status)">
          {{getStatusText(element.status)}}
        </mat-chip>
      </td>
    </ng-container>



    <!-- Messages Sent Column -->
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef> {{paymentPlaceHolder['TBL_DESCRIPTION']}} </th>
      <td mat-cell *matCellDef="let element"> {{ element.description ? placeHolders[element.description] : element.type
        }} </td>
    </ng-container>
    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef> Type</th>
      <td mat-cell *matCellDef="let element"> {{ element.type ? element.type : '-'}}</td>
    </ng-container>

    <!-- Messages Sent Column -->
    <ng-container matColumnDef="card">
      <th mat-header-cell *matHeaderCellDef> {{toolTips['TIP_16']}} </th>
      <td mat-cell *matCellDef="let element"> {{ element.card ? element.card: 'NA'}} </td>
    </ng-container>


    <!-- Current Pending Prospects Column -->
    <ng-container matColumnDef="display_brand">
      <th mat-header-cell *matHeaderCellDef> {{paymentPlaceHolder['TBL_CARD_TYPE']}}</th>
      <td mat-cell *matCellDef="let element"><img width="50px"
          [src]="getCardBrandImage(element.display_brand)">{{element.display_brand}} </td>
    </ng-container>
    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef> Action</th>
      <td mat-cell *matCellDef="let element">
        <!-- <button class="btn btn-sm btn-primary" (click)="openReceipt(element)">
          View Receipt
        </button> -->
        <svg *ngIf="element.status !== 'failed'" xmlns="http://www.w3.org/2000/svg"
          matTooltip="{{dashboardPlaceHolder['LBL_VIEW_RECEIPT']}}" matTooltipPosition="above"
          (click)="openReceipt(element)"
          viewBox="0 0 640 640"><!--!Font Awesome Free v7.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
          <path fill="#36849d"
            d="M142 66.2C150.5 62.3 160.5 63.7 167.6 69.8L208 104.4L248.4 69.8C257.4 62.1 270.7 62.1 279.6 69.8L320 104.4L360.4 69.8C369.4 62.1 382.6 62.1 391.6 69.8L432 104.4L472.4 69.8C479.5 63.7 489.5 62.3 498 66.2C506.5 70.1 512 78.6 512 88L512 552C512 561.4 506.5 569.9 498 573.8C489.5 577.7 479.5 576.3 472.4 570.2L432 535.6L391.6 570.2C382.6 577.9 369.4 577.9 360.4 570.2L320 535.6L279.6 570.2C270.6 577.9 257.3 577.9 248.4 570.2L208 535.6L167.6 570.2C160.5 576.3 150.5 577.7 142 573.8C133.5 569.9 128 561.4 128 552L128 88C128 78.6 133.5 70.1 142 66.2zM232 200C218.7 200 208 210.7 208 224C208 237.3 218.7 248 232 248L408 248C421.3 248 432 237.3 432 224C432 210.7 421.3 200 408 200L232 200zM208 416C208 429.3 218.7 440 232 440L408 440C421.3 440 432 429.3 432 416C432 402.7 421.3 392 408 392L232 392C218.7 392 208 402.7 208 416zM232 296C218.7 296 208 306.7 208 320C208 333.3 218.7 344 232 344L408 344C421.3 344 432 333.3 432 320C432 306.7 421.3 296 408 296L232 296z" />
        </svg>
      </td>
    </ng-container>



    <!-- Total Spent Column -->
    <!-- <ng-container matColumnDef="totalSpent">
      <th mat-header-cell *matHeaderCellDef>{{placeHolders['LBL_TBL_TOTAL_SPENT']}}</th>
      <td mat-cell *matCellDef="let element"> {{element.totalSpent}} </td>
    </ng-container> -->

    <!-- Row definition -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" style="cursor: pointer;" (click)="onRowClicked(row)">
    </tr>
  </table>
  <!--   
    <mat-paginator [length]="recordTotalCount"
                   [pageSize]="5"
                   [pageSizeOptions]="[5, 10, 20]">
    </mat-paginator> -->

</div>


<ng-template #receiptModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Payment Receipt</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body">
    <div class="p-3 border rounded bg-white">
      <!-- Logo -->
      <div class="text-center mb-3">
        <img [src]="receiptlogo" alt="Company Logo" height="100" />
      </div>
      <h4 class="text-center mb-4">{{dashboardPlaceHolder['LBL_PAYMENT_RECEIPT']}}</h4>

      <!-- Merchant Info -->
      <table class="table table-bordered">
        <thead class="table-success">
          <tr>
            <th>{{dashboardPlaceHolder['LBL_TO']}}</th>
            <th>{{dashboardPlaceHolder['LBL_FROM']}}</th>
            <th>{{dashboardPlaceHolder['LBL_DATE']}}</th>
            <th>{{dashboardPlaceHolder['LBL_RECEIPT_ID']}}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              {{ userData.marketplace_name }}<br>
              {{ userData.addressLine1 }}<br>
              {{ userData.business_contact_number }}<br>
              {{ userData.uuid }}
            </td>
            <td>
              MapMyId Inc. (AKA Ship2myid)<br> 
              Address: Alpharetta, Georgia - 30005 <br>
              GST Number:<br>
              PAN Number:
            </td>
            <!-- <td>{{ selectedDeal?.date | date:'dd MMM yyyy' }}</td> -->
            <td>{{ (selectedDeal?.date ?? selectedDeal?.createdAt) | date:'dd MMM yyyy' : '-' }}</td>
            <td>{{ selectedDeal?.receiptId || '-' }}</td>
          </tr>
        </tbody>
      </table>

      <!-- Deal Details -->
      <div *ngIf="selectedDeal?.type !== 'TOPUP'">
        <table class="table table-bordered">
          <thead class="table-success">
            <tr>
              <th>Deal Name</th>
              <th>Deal Id</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ selectedDeal?.name || selectedDeal?.dealDetails?.product_name || 'NA' }}</td>
              <td>{{ selectedDeal?.email || selectedDeal?.referenceId ||'-' }}</td>
            </tr>
          </tbody>
        </table>
      </div>



      <!-- Payment Table -->
      <table class="table table-bordered">
        <thead class="table-success">
          <tr>
            <th>Amount paid for</th>
            <th>{{dashboardPlaceHolder['LBL_DATE_FOR_PAYMENT']}}</th>
            <th>{{dashboardPlaceHolder['PAY_STATUS']}}</th>
            <th>{{dashboardPlaceHolder['LBL_PAYMENT_METHOD']}}</th>
            <th>{{dashboardPlaceHolder['LBL_AMOUNT']}}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="width: 40%;">{{ placeHolders[selectedDeal?.description] ||
              selectedDeal?.dealDetails?.product_name }} – {{ selectedDeal?.type }}</td>
            <!-- <td>{{ selectedDeal?.date | date:'dd MMM yyyy' }}</td> -->
            <td>{{ (selectedDeal?.date ?? selectedDeal?.createdAt) | date:'dd MMM yyyy' : '-' }}</td>
            <td><mat-chip [ngClass]="getStatusClass(selectedDeal?.status)">
                {{ getStatusText(selectedDeal?.status || selectedDeal?.type) }}
              </mat-chip></td>
            <td>{{ selectedDeal?.display_brand }} {{ selectedDeal?.card || getPaymentMethodText(selectedDeal?.type )}} </td>
            <!-- <td>${{ selectedDeal?.amount.toFixed(2) }}</td> -->

            <td>{{ (selectedDeal.amount.toFixed(2) < 0 ? selectedDeal.amount.toFixed(2) * -1 :
                selectedDeal.amount.toFixed(2)) }}</td>
          </tr>
        </tbody>
      </table>

      <!-- Summary -->
      <table class="table table-bordered w-50 ms-auto">
        <tbody>
          <tr class="table-success">
            <td><b>SUBTOTAL</b></td>
            <td class="text-end">${{ (selectedDeal.amount.toFixed(2) < 0 ? selectedDeal.amount.toFixed(2) * -1 :
                selectedDeal.amount.toFixed(2)) }}</td>
          </tr>
          <tr class="table-success">
            <td><b>VAT/GST</b></td>
            <td class="text-end">$0.00</td>
          </tr>
          <tr class="table-success">
            <td><b>TOTAL</b></td>
            <td class="text-end">${{ (selectedDeal.amount.toFixed(2) < 0 ? selectedDeal.amount.toFixed(2) * -1 :
                selectedDeal.amount.toFixed(2)) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn btn-primary" (click)="downloadPDF()">{{dashboardPlaceHolder['LBL_DOWNLOAD']}}</button>
    <button class="btn btn-secondary" (click)="modal.dismiss()">{{dashboardPlaceHolder['LBL_CLOSE']}}</button>
  </div>
</ng-template>


<table class="table table-hover" *ngIf="userData.paymentMode ==='WALLET'">
  <thead>
    <tr>
      <!-- <th>Transaction ID</th> -->
      <th>Reference ID</th>
      <th>Date</th>
      <th>Amount</th>
      <th>Payment method</th>
      <th>Payment status</th>
      <th>Action</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let txn of transactions">
      <!-- <td>
        <a href="javascript:void(0)" (click)="viewTransaction(txn)">
          {{ txn.id }}
        </a>
      </td> -->
      <td>
        {{ txn.referenceId || '—' }}
      </td>
      <td>{{ txn.createdAt | date:'MMM d, yyyy' }}</td>
      <td>
        <!-- {{ txn.amount | currency:txn.currency.toUpperCase() }} -->
        {{ (txn.amount < 0 ? txn.amount * -1 : txn.amount) | currency:txn.currency.toUpperCase() }} </td>
      <td>
        <span *ngIf="txn.type === 'TOPUP'">Manual Payment</span>
        <span *ngIf="txn.type === 'CONSUME'">Prepaid balance </span>
        <span *ngIf="txn.type === 'RESERVE'">Allocated </span>
        <span *ngIf="txn.type === 'RESERVE_UPDATE'">Reversed </span>
        <span *ngIf="txn.type === 'RELEASE'">Reversed </span>
        

      </td>
      <td>
        <span class="badge bg-success" *ngIf="txn.type === 'TOPUP'">Funded</span>
        <span class="badge bg-success" *ngIf="txn.type === 'CONSUME'">
          Paid
        </span>
         <span class="badge bg-warning" *ngIf="txn.type === 'RESERVE_UPDATE'">
          Refunded
        </span>
        <span class="badge bg-warning" *ngIf="txn.type === 'RELEASE'">
          Refunded
        </span>
      </td>

      <td>
        <!-- <button class="btn btn-primary btn-sm" (click)="openReceipt(txn)">
          <i class="bi bi-download">Receipt</i>
        </button> -->
        <svg *ngIf="txn.type !== 'RESERVE'" xmlns="http://www.w3.org/2000/svg"
          matTooltip="{{dashboardPlaceHolder['LBL_VIEW_RECEIPT']}}" matTooltipPosition="above"
          (click)="openReceipt(txn)" width="1.5em" height="1.5em"
          viewBox="0 0 640 640"><!--!Font Awesome Free v7.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
          <path fill="#36849d"
            d="M142 66.2C150.5 62.3 160.5 63.7 167.6 69.8L208 104.4L248.4 69.8C257.4 62.1 270.7 62.1 279.6 69.8L320 104.4L360.4 69.8C369.4 62.1 382.6 62.1 391.6 69.8L432 104.4L472.4 69.8C479.5 63.7 489.5 62.3 498 66.2C506.5 70.1 512 78.6 512 88L512 552C512 561.4 506.5 569.9 498 573.8C489.5 577.7 479.5 576.3 472.4 570.2L432 535.6L391.6 570.2C382.6 577.9 369.4 577.9 360.4 570.2L320 535.6L279.6 570.2C270.6 577.9 257.3 577.9 248.4 570.2L208 535.6L167.6 570.2C160.5 576.3 150.5 577.7 142 573.8C133.5 569.9 128 561.4 128 552L128 88C128 78.6 133.5 70.1 142 66.2zM232 200C218.7 200 208 210.7 208 224C208 237.3 218.7 248 232 248L408 248C421.3 248 432 237.3 432 224C432 210.7 421.3 200 408 200L232 200zM208 416C208 429.3 218.7 440 232 440L408 440C421.3 440 432 429.3 432 416C432 402.7 421.3 392 408 392L232 392C218.7 392 208 402.7 208 416zM232 296C218.7 296 208 306.7 208 320C208 333.3 218.7 344 232 344L408 344C421.3 344 432 333.3 432 320C432 306.7 421.3 296 408 296L232 296z" />
        </svg>
      </td>
    </tr>
  </tbody>
</table>
<div class="pt-2">
  <app-pagination [totalRecords]="totalCount" [recordsPerPage]="pageSize" [activePage]="activePage"
    (onPageChange)="onPageChange($event)"></app-pagination>
</div>